<template>
  <div class="about">
    <div class="article-cover">
      <img src="https://res.smoktech.com/files/5d32be98/article3.png" alt>
    </div>
    <div class="about-content">
      <h1 class="title">IVPS Tour Terms of Use</h1>
      <div class="article">
        <p>Last updated: March 19, 2019</p>
        <h2>1. Your Relationship With Us</h2>
        <p>IVPS Tour, including the Mobile App and Website(the “Platform”), which are provided by Shenzhen IVPS Technology Co.,Ltd. (collectively such entities will be referred to as “IVPS”, “we” or “us”).</p>
        <p>You are reading the Terms of Use (the “Terms”), which govern the relationship and serve as an agreement between you and us and set forth the terms and conditions by which you may access and use the Platform and our related websites, services, applications, products and content (collectively, the “Services”). For purposes of these Terms, “you” and “your” means you as the user of the Services.</p>
        <p>
          The Terms form a legally binding agreement between you and us. Please take the time to read them carefully.Your use of the IVPS Tour is also governed by our
          <router-link to="/privacy-policy">Privacy Policy</router-link>, which is incorporated into and made a part of this Agreement.
        </p>
        <h2>2. Accepting the Terms</h2>
        <p>Subject to your agreement to and compliance with this terms of use, we grant to you a non-exclusive, non-transferable, non-sharable, revocable, limited license to use the Services soley for your personal, non-commercial use to the Services in accordance with this Terms.</p>
        <p>Please make sure: BY ENTERING THIS APP YOU HEREBY AFFIRM AND WARRANT THAT YOU ARE 21 YEARS OLD OR OLDER.</p>
        <p>If you are accessing or using the Services on behalf of a business or entity, then (a) “you” and “your” includes you and the business or entity you represent for, (b) you warrant you are the authorized representative of the business or entity to the Terms on the business or entity’s behalf, and (c) your business or entity is legally and financially responsible for your access or use of the Services as well as for the access or use of your account by others affiliated with your entity, including any employees, agents or contractors.</p>
        <p>You can accept the Terms by accessing or using our Services. You understand and agree that we will treat your access or use of the Services as acceptance of the Terms from that point onwards. If you do not agree with any of these Terms, you would not be able to use or access this APP.</p>
        <h2>3. Right to update and modify the Terms</h2>
        <p>
          We may amend these Terms from time to time, for instance when we update the
          functionality of our Services, combine multiple apps or services operated by us or our
          affiliates into a single combined service or app, or there are regulatory changes. Please check
          the Terms periodically for changes. We will use commercially reasonable efforts to generally
          notify all users of any material changes to these Terms, such as through a notice on our
          Platform, however, you should look at the Terms regularly to check for such changes. We
          will also update the “Last Updated” date at the top of these Terms, which reflect the effective
          date of such Terms. Your continued access or use of the Services after the date of the new
          Terms constitutes your acceptance of the new Terms.
        </p>
        <h2>4. Your Account with Us</h2>
        <p>
          To access or use some of our Services, you must create an account with us. When you create
          this account, you must provide accurate and up-to-date information. It is important that you
          maintain and promptly update your details and any other information you provide to us, to
          keep such information current and complete.
        </p>
        <p>
          It is important that you keep your account password confidential and that you do not
          disclose it to any third party. If you know or suspect that any third party knows your
          password or has accessed your account, you must promptly notify us by the email address at
          the end of this Terms.
        </p>
        <p>
          You agree that you are solely responsible (to us and to others) for the activity that occurs
          under your account.
        </p>
        <h2>5. Termination of the Account</h2>
        <p>
          We reserve the right to disable your user account at any time, including if you have failed to
          comply with any of the provisions of these Terms, or if activities occur on your account
          which, in our sole discretion, would or might cause damage to or impair the Services or
          infringe or violate any third party rights, or violate any applicable laws or regulations.
        </p>
        <p>
          Notwithstanding, you may delete your account at any time by sending an email. Deletion will
          be effective within 7 working days. Once you choose to delete your account, you will not be
          able to reactivate your account or retrieve any of the content or information you have added.
        </p>
        <h2>6. Your Access to and Use of Our Services</h2>
        <p>
          Your access to and use of the Services is subject to these Terms and all applicable laws and
          regulations. You will not violate any applicable law, contract, intellectual property or other
          third-party right or commit a tort, and you are solely responsible for your conduct while
          accessing or using the Platform. In connection with your use of the Platform and the Services,
          you will not:
        </p>
        <ul>
          <li>
            access or use the Services if you are not fully able and legally competent to agree to
            these Terms;
          </li>
          <li>
            make unauthorised copies, modify, adapt, translate, reverse engineer, disassemble,
            decompile or create any derivative works of the Services or any content included
            therein, including any files, tables or documentation (or any portion thereof) or
            determine or attempt to determine any source code, algorithms, methods or techniques
            embodied by the Services or any derivative works thereof;
          </li>
          <li>
            distribute, license, transfer, or sell, in whole or in part, any of the Services or any
            derivative works thereof;
          </li>
          <li>
            market, rent or lease the Services for a fee or charge, or use the Services to advertise or
            perform any commercial solicitation;
          </li>
          <li>
            use the Services, without our express written consent, for any commercial or
            unauthorized purpose, including communicating or facilitating any commercial
            advertisement or solicitation or spamming;
          </li>
          <li>
            interfere with or attempt to interfere with the proper working of the Services, disrupt
            our website or any networks connected to the Services, or bypass any measures we may
            use to prevent or restrict access to the Services;
          </li>
          <li>
            incorporate the Services or any portion thereof into any other program or product. In
            such case, we reserve the right to refuse service, terminate accounts or limit access to
            the Services in our sole discretion;
          </li>
          <li>
            use automated scripts to collect information from or otherwise interact with the
            Services;
          </li>
          <li>
            impersonate any person or entity, or falsely state or otherwise misrepresent you or
            your affiliation with any person or entity, including giving the impression that any
            content you upload, post, transmit, distribute or otherwise make available emanates
            from the Services;
          </li>
          <li>
            intimidate or harass another, or promote sexually explicit material, violence or
            discrimination based on race, sex, religion, nationality, disability, sexual orientation or
            age;
          </li>
          <li>
            use or attempt to use another account, service or system without authorisation from us,
            or create a false identity on the Services;
          </li>
          <li>
            use the Services in a manner that may create a conflict of interest or undermine the
            purposes of the Services, such as trading reviews with other users or writing or
            soliciting fake reviews;
          </li>
          <li>
            Other types of actions, in our sole discretion, which are unlawful or breaching this
            Terms.
          </li>
          <li>
            use the Services to upload, transmit, distribute, store or otherwise make available in
            any way:files that contain viruses, trojans, worms, logic bombs or other material that is
            malicious or technologically harmful;any unsolicited or unauthorised advertising,
            solicitations, promotional materials, “junk mail,” “spam,” “chain letters,” “pyramid
            schemes,” or any other prohibited form of solicitation;any private information of any
            third party, including addresses, phone numbers, email addresses, number and feature
            in the personal identity document (e.g., National Insurance numbers, passport numbers)
            or credit card numbers;any material which does or may infringe any copyright, trade
            mark or other intellectual property or privacy rights of any other person;any material
            which is defamatory of any person, obscene, offensive, pornographic, hateful or
            inflammatory;any material that would constitute, encourage or provide instructions for
            a criminal offence, dangerous activities or self-harm;any material that is deliberately
            designed to provoke or antagonise people, especially trolling and bullying, or is
            intended to harass, harm, hurt, scare, distress, embarrass or upset people;any material
            that contains a threat of any kind, including threats of physical violence;any material
            that is racist or discriminatory, including discrimination on the basis of someone’s race,
            religion, age, gender, disability or sexuality;
          </li>
        </ul>
        <p>
          - any answers, responses, comments, opinions, analysis or recommendations that you
          are not properly licensed or otherwise qualified to provide; or
        </p>
        <p>
          - material that, in the sole judgment of IVPS, is objectionable or which restricts or
          inhibits any other person from using the Services, or which may expose IVPS, the Services or
          its users to any harm or liability of any type.
        </p>
        <p>
          We reserve the right, at any time and without prior notice, to remove or disable your access
          to content at our discretion for any reason or no reason. Some of the reasons we may
          remove or disable access to content may include finding the content objectionable, in
          violation of these Terms, or otherwise harmful to the Services or our users. Our automated
          systems analyze your content (including emails) to provide you personally relevant product
          features, such as customized search results, tailored advertising, and spam and malware
          detection. This analysis occurs as the content is sent, received, and when it is stored.
        </p>
        <h2>7. Intellectual Property Rights</h2>
        <p>
          We respect intellectual property rights and ask you to do the same. We are the owner or the
          licensee of all intellectual property rights in the Platform, and in the material published on it.
          Those works are protected by copyright laws and treaties around the world. All such rights
          are reserved. In accessing the Platform you agree that you will access its contents and use
          the Services solely for your personal, non-commercial use. The platform, including parts of it,
          may not be downloaded, copied, reproduced, transmitted, stored, sold or distributed
          without the prior written consent of the copyright holder. This excludes the downloading,
          copying and/or printing of pages of the Platform for personal, non-commercial home use
          only.
        </p>
        <p>
          As a condition of your access to and use of the Services, you agree not to use the Services to
          infringe on any intellectual property rights. We reserve the right, with or without notice, at
          any time and in our sole discretion to block access to and/or terminate the accounts of any
          user who infringes or is alleged to infringe any copyrights or other intellectual property
          rights.
        </p>
        <h2>8. Content</h2>
        <h3>8.1 Your Content</h3>
        <p>
          The Services may contain information, text, links, graphics, photos, videos, or other materials
          (“Content”), including Content created with or submitted to the Services by you or through
          your Account (“Your Content”). We take no responsibility for and we do not expressly or
          implicitly endorse any of Your Content.
        </p>
        <p>
          By submitting Your Content to the Services, you represent and warrant that you have all
          rights, power, and authority necessary to grant the rights to Your Content contained within
          these Terms. Because you alone are responsible for Your Content, you may expose yourself
          to liability if you post or share Content without all necessary rights.
        </p>
        <p>
          You retain any ownership rights you have in Your Content, but you grant IVPS Tour the
          following license to use that Content:
        </p>
        <p>
          When Your Content is created with or submitted to the Services, you grant us a worldwide,
          royalty-free, perpetual, irrevocable, non-exclusive, transferable, and sublicensable license to
          use, copy, modify, adapt, prepare derivative works from, distribute, perform, and display
          Your Content and any name, username, voice, or likeness provided in connection with Your
          Content in all media formats and channels now known or later developed. This license
          includes the right for us to make Your Content available for syndication, broadcast,
          distribution, or publication by other companies, organizations, or individuals who partner
          with IVPS Tour. You also agree that we may remove metadata associated with Your Content,
          and you irrevocably waive any claims and assertions of moral rights or attribution with
          respect to Your Content.
        </p>
        <p>
          Any ideas, suggestions, and feedback about IVPS Tour or our Services that you provide to us
          are entirely voluntary, and you agree that we may use such ideas, suggestions, and feedback
          without compensation or obligation to you.
        </p>
        <p>
          Although we have no obligation to screen, edit, or monitor Your Content, we may, in our sole
          discretion, delete or remove Your Content at any time and for any reason, including for a
          violation of these Terms, a violation of our Content Policy, or if you otherwise create liability
          for us.
        </p>
        <h3>8.2 Third-Party Content, Advertisements and Promotions</h3>
        <p>
          The Services may contain links to third-party websites, products, or services, which may be
          posted by advertisers, our affiliates, our partners, or other users (“Third-Party Content”).
          Third-Party Content is not under our control, and we are not responsible for any of their
          websites, products, or services. Your use of Third-Party Content is at your own risk and you
          should make any investigation you feel necessary before proceeding with any transaction in
          connection with such Third-Party Content.
        </p>
        <p>
          The Services may also contain sponsored Third-Party Content or advertisements. The type,
          degree, and targeting of advertisements are subject to change, and you acknowledge and
          agree that we may place advertisements in connection with the display of any Content or
          information on the Services, including Your Content.
        </p>
        <p>
          If you choose to use the Services to conduct a promotion, including a contest or sweepstakes,
          you alone are responsible for conducting the promotion in compliance with all applicable
          laws and regulations. The terms of your promotion must specifically state that the
          promotion is not sponsored by, endorsed by, or associated with IVPS Tour and the rules for
          your promotion must require each entrant or participant to release IVPS Tour from any
          liability related to the promotion.
        </p>
        <h2>9. Disclaimers</h2>
        <p>
          THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF
          ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED
          WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
          NON-INFRINGEMENT. IVPS TOUR, ITS LICENSORS, AND ITS THIRD PARTY SERVICE
          PROVIDERS DO NOT WARRANT THAT THE SERVICES ARE ACCURATE, COMPLETE,
          RELIABLE, CURRENT, OR ERROR FREE. IVPS TOUR DOES NOT CONTROL, ENDORSE, OR
          TAKE RESPONSIBILITY FOR ANY CONTENT AVAILABLE ON OR LINKED TO THE SERVICES
          OR THE ACTIONS OF ANY THIRD PARTY OR USER, INCLUDING MODERATORS. WHILE IVPS
          TOUR ATTEMPTS TO MAKE YOUR ACCESS TO AND USE OF OUR SERVICES SAFE, WE DO
          NOT REPRESENT OR WARRANT THAT OUR SERVICES OR SERVERS ARE FREE OF VIRUSES
          OR OTHER HARMFUL COMPONENTS. YOU SHOULD USE YOUR JUDGEMENT AND EXERCISE
          CAUTION WHERE APPROPRIATE. SOME ASPECTS OF THIS SECTION MAY NOT APPLY IN
          SOME JURISDICTIONS IF PROHIBITED BY APPLICABLE LAW.
        </p>
        <p>THIS DOES NOT AFFECT YOUR STATUTORY RIGHTS AS A CONSUMER.</p>
        <h2>10. Governing Law</h2>
        <p>
          The Agreements (and any non-contractual disputes/claims arising out of or in connection
          with them) are subject to the laws of the People’s Republic of China, without regard to choice
          or conflicts of law principles.
        </p>
        <h2>11. Termination</h2>
        <p>
          You may terminate these Terms at any time and for any reason by deleting your Account and
          discontinuing your use of all Services. If you stop using the Services without deactivating
          your Accounts, your Accounts may be deactivated due to prolonged inactivity.
        </p>
        <p>
          We may suspend or terminate your Accounts, status as a moderator, or ability to access or
          use the Services at any time for any or no reason, including for a violation of these Terms.
        </p>
        <p>
          The following sections will survive any termination of these Terms or of your Accounts: 6
          (Your Access to and Use of Our Services), 8 (Content), 9 (Disclaimers), 11 (Termination),
          and 12 (Miscellaneous).
        </p>
        <h2>12. Miscellaneous</h2>
        <p>
          These Terms constitute the entire agreement between you and us regarding your access to
          and use of the Services. Our failure to exercise or enforce any right or provision of these
          Terms will not operate as a waiver of such right or provision. If any provision of these Terms
          is, for any reason, held to be illegal, invalid or unenforceable, the rest of the Terms will
          remain in effect. You may not assign or transfer any of your rights or obligations under these
          Terms without our consent. We may freely assign these Terms.
        </p>
        <h2>13. Contact Us</h2>
        <p>
          If you have further questions, please contact us via email:
          <a
            href="mailto:ivpstour@smoktech.com"
          >ivpstour@smoktech.com</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  padding-left: 20px;
}

ul ul {
  padding-left: 0;
}

ul p {
  display: inline-block;
  margin-left: -20px;
}

h2,
h3,
h4 {
  color: #252525;
}
h2 {
  margin: 44px 0 24px;
  font-size: 20px;
}

h3 {
  margin: 24px 0;
  font-size: 18px;
}

h4 {
  margin: 24px 0 0;
  font-size: 16px;
}

.about {
  /* overflow: hidden; */
  background: rgba(255, 255, 255, 0.45);
  /* width: 500px; */
  height: 720px;
  padding: 40px 0 40px 40px;
  border: 2px #ffffff solid;
  border-radius: 20px;
  box-shadow: 2px 2px 35px 2px rgba(0, 0, 0, 0.1);
}

.article-cover {
  display: none;
}

.about-content {
  height: 640px;
  overflow-y: auto;
  margin-right: -2px;
  padding-right: 20px;
}

.about-content::-webkit-scrollbar {
  width: 14px;
  height: 1px;
}
.about-content::-webkit-scrollbar-thumb {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #ccc;
}
.about-content::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #ededed;
}
.title,
.contact,
.signature a {
  font-size: 20px;
  color: #252525;
}

.title {
  position: relative;
  padding: 24px 0;
}

.title::after,
.contact::after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  background: #ccc;
  width: 76px;
}

.article p {
  margin-top: 24px;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 24px;
  color: #333;
}

.contact {
  position: relative;
  margin: 65px 0 0;
  padding-bottom: 24px;
}

.signature a {
  display: inline-block;
  margin: 24px 0;
}

@media (max-width: 1024px) {
  .about {
    padding: 0;
  }

  .article-cover {
    display: inline-block;
    width: 100%;
    height: auto;
  }

  .article-cover img {
    object-fit: contain;
    width: 100%;
    height: auto;
  }

  .about-content {
    padding: 34px 40px 40px;
    text-align: left;
  }

  .title::after,
  .contact::after {
    /* width: 100%; */
  }
  @media (max-width: 750px) {
    .about {
      /* position: absolute;
      top: 78px;
      left: 0;
      width: 100%; */
      height: auto;
      background: #ffffff;
      overflow: hidden;
      border-radius: 0;
      border: none;
    }

    .about-content {
      height: auto;
    }

    .article-cover {
      /* margin: -40px 0 0 -40px; */
    }
  }
}
</style>
